import { createAction, props } from '@ngrx/store';
import type { TaskReferenceItem } from './task-reference.models';

export const TaskReferenceLoadRequest = createAction('[Task Reference] Load Request');
export const TaskReferenceLoadSuccess = createAction(
  '[Task Reference] Load Success',
  props<{ items: TaskReferenceItem[] }>(),
);
export const TaskReferenceLoadFailure = createAction(
  '[Task Reference] Load Failure',
  props<{ error: string }>(),
);
